export const headers = {

  methods: {
    headers(accessToken) {
      return {
        "x-access-token": accessToken
      }
    },
    headersUploadStream(accessToken) {
      return {
        "x-access-token": accessToken,
        "content-type": 'application/octet-stream'
      }
    }
  }
}
